import type { TFunction } from "i18next";
import type { Menu } from "./constants";

/** "/setting/multi-lang/app" -> "setting_multi_lang_app" (key trong sidebar.menu.*). */
export const menuI18nKey = (path: string) =>
  path.replace(/^\//, "").replace(/[/-]/g, "_");

/** Tên menu theo ngôn ngữ hiện tại; thiếu key thì dùng tên gốc tiếng Anh. */
export const translateMenuName = (t: TFunction, menu: Pick<Menu, "path" | "name">) =>
  t(`sidebar.menu.${menuI18nKey(menu.path)}`, { defaultValue: menu.name });
